<div class="axis-content-wrapper">
  <div class="axis-container-fluid">
    <div class="custom-wrapper theme-dark">
      <div class="aig-logo">
        <img
          alt="AIG logo"
          src="assets/images/logos/aig-logo-white.svg"
        />
      </div>
      <div class="axis-grid _align-items-center _row-gap-large">
        <div class="axis-col-lg-8 _flex-last _flex-lg-unordered">
          <h1>Welcome to the UM/UIM & PIP Coverage Selection Tool</h1>

          <div class="_text-readability axis-h3">
            <p class="_text-italic _text-bold">Powered by Coversign™</p>
            <p>Today you will be completing:</p>
            <ul>
              @if (hasUMUIM) {
                <li>Uninsured and Underinsured Motorist Coverage Selection Forms</li>
              }
              @if (hasPIP) {
                <li>Personal Injury Protection Coverage Selection Forms</li>
              }
            </ul>
          </div>
          <a
            href="#"
            class="axis-btn kind-secondary"
            (click)="btnStart_clickHandler($event)"
          >
            <span class="axis-btn-icon-text"> Let's Get Started </span>
            <axis-icon
              icon="chevron_right"
              font="custom"
            ></axis-icon>
          </a>
        </div>
        <div class="axis-col-lg-4">
          <img
            alt=""
            class="axis-img-responsive _mlr-auto"
            src="assets/images/messages/home.svg"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
</div>
